import { Result } from '@/core/models/Result';
import GlobalDataStorageFactory from '../factories/GlobalDataStorageFactory';

export default class MarkedAsCanFetchGlobalDataUseCase {
    private globalDataStorageRepo = GlobalDataStorageFactory.makeRepo();

    public invoke() {
        const result = new Result<unknown>();

        this.globalDataStorageRepo.canFetchData();

        result.success = true;
        return result;
    }
}
